
import AppHeader from '@/components/Header.vue'
import { defineComponent, computed, ref, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue'
import { PullRefresh, Toast, Dialog, Stepper } from 'vant'
import {
  getTimeByBYJSn,
  getImageUrlByUuid,
  payReserveOrder,
  searchByjPayStatus,
} from '@/apis/service'
import appHost from '@/utils/app'
import { useStore } from 'vuex'
import wx from 'weixin-js-sdk'
export default defineComponent({
  name: 'BuyUseTime',
  components: {
    AppHeader,
    vanPullRefresh: PullRefresh,
    vanStepper: Stepper,
  },
  setup() {
    const loading = ref(false)
    const { proxy } = getCurrentInstance()
    const reserveDeviceList = ref([])
    const searchInterval = ref(0)
    const store = useStore() // vuestore
    const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
    const amountPrice = computed(() => {
      let price = 0
      for (let i = 0; i < reserveDeviceList.value.length; i++) {
        price +=
          Number(reserveDeviceList.value[i].price) * Number(reserveDeviceList.value[i].buyDays)
      }
      return price
    })
    const onRefresh = async () => {
      await init()
      loading.value = false
    }

    // 初始化加载数据
    const init = async () => {
      let param = {
        sn: proxy.$route.params.sn,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await getTimeByBYJSn(param)
        for (let i = 0; i < result.length; i++) {
          if (result[i].available_day > 0) {
            result[i].buyDays = 1
          } else {
            result[i].buyDays = 0
          }
          try {
            result[i].url = await getImageByGuid(result[i].image_guid)
          } catch (error) {
            console.log(error)
          }
        }
        reserveDeviceList.value = result || []
        toast.clear()
      } catch (error: any) {
        let message = error && error.message ? error.message : '操作失败'
        toast.clear()
        Toast(message)
      }
    }
    const getImageByGuid = async (guid: string) => {
      let param = {
        res_uids: [guid],
      }
      let result: any = await getImageUrlByUuid(param)
      return result[0].url
    }
    // 点击支付
    const handlePayAmount = async () => {
      clearInterval(searchInterval.value)
      let details = []
      for (let i = 0; i < reserveDeviceList.value.length; i++) {
        if (reserveDeviceList.value[i].buyDays >= 1) {
          details.push({
            product_name: reserveDeviceList.value[i].product_name,
            code: reserveDeviceList.value[i].code,
            serial_number: reserveDeviceList.value[i].product_sn,
            day: reserveDeviceList.value[i].buyDays,
            price: Number(reserveDeviceList.value[i].price),
          })
        }
      }
      let param = {
        number: proxy.$route.params.sn,
        total_price: amountPrice.value,
        from_where: '1',
        callback_page_url: '',
        details,
      }
      if (store.getters.isMiniProgram) {
        param.from_where = '2'
        param.callback_page_url = window.location.origin + getCbPageUrl()
        console.log('KL', 'handlePayRepairOrder', param)
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await payReserveOrder(param)
        if (result.order_no && param.from_where === '2') {
          wx.miniProgram.navigateTo({
            url: '/pages/user/pay?guid=' + result.order_no,
          })
        } else if (result.order_no) {
          let query = JSON.parse(JSON.stringify(proxy.$route.query))
          query['order_no'] = result.order_no
          proxy.$router.replace({
            path: `/buyusetime/${proxy.$route.params.sn}/${proxy.$route.params.guid}`,
            query: query,
          })
          appHost.onPay(result.order_no)
          toast.clear()
          handleSearchPayResult()
        } else {
          toast.clear()
          Toast('支付订单号不存在！')
        }
      } catch (error: any) {
        let message = error && error.message ? error.message : '操作失败'
        toast.clear()
        Toast(message)
      }
    }
    const getCbPageUrl = () => {
      return `/afterpay/2/${proxy.$route.params.sn}/${proxy.$route.params.guid}/${amountPrice.value}`
    }
    // 查询支付结果
    const handleSearchPayResult = () => {
      let toast = Toast({
        type: 'loading',
        message: '支付结果查询中',
        forbidClick: false,
        duration: 0,
      })
      let searching = false
      let i = 0
      searchInterval.value = setInterval(async () => {
        // 如果查询超过1分钟 那么给提示
        if (i >= 12) {
          clearInterval(searchInterval.value)
          toast.clear()
          Dialog.confirm({
            title: '查询结果失败',
            message: `支付订单号${proxy.$route.query.order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
            confirmButtonText: '重新查询',
            cancelButtonText: '取消查询',
            className: 'reserve-dialog',
            width: 304,
          })
            .then(async () => {
              try {
                handleSearchPayResult()
              } catch (error: any) {
                Dialog.close()
              }
            })
            .catch(() => {
              Dialog.close()
            })
        }
        // 正常逻辑
        if (searching) {
          return
        }
        searching = true
        let result: any = await searchByjPayStatus({ order_no: proxy.$route.query.order_no })
        if (result.pay_status == 1) {
          toast.clear()
          clearInterval(searchInterval.value)
          // 跳转到支付成功界面
          proxy.$router.replace({
            path: `/afterpay/2/${proxy.$route.params.sn}/${proxy.$route.params.guid}/${amountPrice.value}`,
            query: proxy.$route.query,
          })
        }
        searching = false
        i++
      }, 5000)
    }
    const handleBack = () => {
      proxy.$router.replace(`/reserveorder/${proxy.$route.params.guid}`)
    }
    onMounted(() => {
      init()
    })
    onBeforeUnmount(() => {
      clearInterval(searchInterval.value)
    })
    return {
      loading,
      reserveDeviceList,
      amountPrice,
      pagePaddingTop,
      onRefresh,
      handlePayAmount,
      handleSearchPayResult,
      handleBack,
    }
  },
})
